import { render, staticRenderFns } from "./PhoneFormatter.vue?vue&type=template&id=6b162150"
import script from "./PhoneFormatter.vue?vue&type=script&lang=js"
export * from "./PhoneFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports